import { REPORT_SECTIONS } from '../lib/reports';
import { ReportSection } from './ReportSection';

/**
 * The six report sections.
 *
 * 2026-07 refresh: the heading pair that used to sit above these
 * ("Inside the Orbis Platform" + subtitle) has been removed — it duplicated the
 * one PlatformIntro already renders, and commit dc4386f dropped the second copy.
 * This component is now purely the list.
 */
export function ReportSections() {
  return (
    <>
      {REPORT_SECTIONS.map((section) => (
        <ReportSection key={section.id} section={section} />
      ))}
    </>
  );
}
